import { render } from "./BuyersTerminal.vue?vue&type=template&id=6fe857a4&scoped=true"
import script from "./BuyersTerminal.vue?vue&type=script&lang=js"
export * from "./BuyersTerminal.vue?vue&type=script&lang=js"

import "./BuyersTerminal.vue?vue&type=style&index=0&id=6fe857a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe857a4"]])

export default __exports__